var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90259 23H27.5026V24.5C27.5026 25.5609 27.0811 26.5783 26.331 27.3284C25.5808 28.0786 24.5634 28.5 23.5026 28.5H8.90259C7.84172 28.5 6.8243 28.0786 6.07416 27.3284C5.32401 26.5783 4.90259 25.5609 4.90259 24.5V23Z",
    fill: "url(#paint0_linear_20_676)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8025 16.9H27.4025C27.8048 16.8866 28.2057 16.9543 28.5813 17.099C28.9569 17.2437 29.2996 17.4626 29.5888 17.7425C29.8781 18.0224 30.108 18.3577 30.265 18.7284C30.4219 19.099 30.5027 19.4975 30.5025 19.9C30.5025 20.7222 30.1759 21.5106 29.5946 22.092C29.0132 22.6734 28.2247 23 27.4025 23H5.00252C4.6 23.0002 4.20157 22.9194 3.83092 22.7625C3.46027 22.6055 3.12497 22.3755 2.84505 22.0862C2.56512 21.797 2.34627 21.4544 2.20152 21.0788C2.05678 20.7032 1.9891 20.3023 2.00252 19.9C1.98855 19.5023 2.05662 19.1059 2.20244 18.7356C2.34826 18.3653 2.56873 18.029 2.85014 17.7476C3.13155 17.4662 3.46786 17.2457 3.83815 17.0999C4.20845 16.9541 4.60479 16.886 5.00252 16.9H13.8025",
    fill: "url(#paint1_linear_20_676)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8025 16.9H27.4025C27.8048 16.8866 28.2057 16.9543 28.5813 17.099C28.9569 17.2437 29.2996 17.4626 29.5888 17.7425C29.8781 18.0224 30.108 18.3577 30.265 18.7284C30.4219 19.099 30.5027 19.4975 30.5025 19.9C30.5025 20.7222 30.1759 21.5106 29.5946 22.092C29.0132 22.6734 28.2247 23 27.4025 23H5.00252C4.6 23.0002 4.20157 22.9194 3.83092 22.7625C3.46027 22.6055 3.12497 22.3755 2.84505 22.0862C2.56512 21.797 2.34627 21.4544 2.20152 21.0788C2.05678 20.7032 1.9891 20.3023 2.00252 19.9C1.98855 19.5023 2.05662 19.1059 2.20244 18.7356C2.34826 18.3653 2.56873 18.029 2.85014 17.7476C3.13155 17.4662 3.46786 17.2457 3.83815 17.0999C4.20845 16.9541 4.60479 16.886 5.00252 16.9H13.8025",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5026 14.9C30.4951 15.4275 30.2795 15.9307 29.9027 16.3C29.7273 16.4963 29.5111 16.6517 29.2692 16.7554C29.0273 16.8591 28.7657 16.9084 28.5026 16.9H23.3027L19.9027 20.8L16.5026 16.9H3.90266C3.6445 16.9004 3.38897 16.8481 3.15168 16.7464C2.91439 16.6448 2.7003 16.4958 2.5225 16.3086C2.3447 16.1215 2.20691 15.9 2.11753 15.6579C2.02815 15.4157 1.98905 15.1578 2.00263 14.9C1.98905 14.6422 2.02815 14.3843 2.11753 14.1422C2.20691 13.9 2.3447 13.6785 2.5225 13.4914C2.7003 13.3042 2.91439 13.1553 3.15168 13.0536C3.38897 12.9519 3.6445 12.8996 3.90266 12.9H28.5026C29.0331 12.9 29.5418 13.1107 29.9169 13.4858C30.292 13.8609 30.5026 14.3696 30.5026 14.9Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5026 4H19.0026C21.2834 4 23.4709 4.90606 25.0837 6.51888C26.6965 8.13169 27.6026 10.3191 27.6026 12.6H4.90259C4.90259 10.3191 5.80863 8.13169 7.42145 6.51888C9.03426 4.90606 11.2217 4 13.5026 4Z",
    fill: "url(#paint2_linear_20_676)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6025 8.5L11.8026 9.8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4028 8L22.7028 9.39999",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4026 8.59999L16.8026 7.29999",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_676",
    x1: 4.98118,
    y1: 23.8554,
    x2: 7.94083,
    y2: 34.1358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26702"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_676",
    x1: 30.5025,
    y1: 23,
    x2: 28.0044,
    y2: 11.3312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3AF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20_676",
    x1: 4.98153,
    y1: 5.33752,
    x2: 11.4781,
    y2: 19.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26702"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.890fadd21bffde623520b748bfd623f9.svg";
export { ForwardRef as ReactComponent };